import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function maxDecimalValidator(value?: number): ValidatorFn {

  return (control: AbstractControl): ValidationErrors | null => {

    const tmpValue = String(control.value).replace(/\,/g, '.');
    const inputValue = parseFloat(tmpValue);

    if (
      !control.value 
    ) {
      return { decMax: true };
    }
    if (value && inputValue > value) {
      console.log(`El valor ${inputValue} es mayor a ${value}`)
      return { decMax: true };
    }

    return null;
  }
    
}
